import { styled } from "@mui/system";
import { Chip } from "@mui/material";
import BryxColors from "../../types/theme";
const chipStyleMapping = (style, palette) => {
    switch (style) {
        case "stageComplete":
            return {
                border: `2px solid ${BryxColors.specialColor(palette).passwordStrengthChipComplete}`,
                backgroundColor: `${BryxColors.specialColor(palette).passwordStrengthChipComplete} !important`,
            };
        case "allComplete":
            return {
                border: `2px solid ${BryxColors.specialColor(palette).passwordStrengthAllChipsComplete}`,
                backgroundColor: `${BryxColors.specialColor(palette).passwordStrengthAllChipsComplete} !important`,
            };
        default:
            return {
                border: `1px solid ${BryxColors.specialColor(palette).passwordStrengthChipIncomplete}`,
                backgroundColor: `${BryxColors.specialColor(palette).passwordStrengthChipIncomplete} !important`,
            };
    }
};
const BryxPasswordStrengthChip = styled(Chip)(({ theme, className }) => {
    const palette = theme.palette.mode;
    return {
        "& .MuiChip-label": {
            padding: "0px 0px 0px 0px",
        },
        display: "flex",
        boxShadow: "none !important",
        height: "4px",
        width: "25px",
        borderRadius: "4px",
        flexGrow: 1,
        ...chipStyleMapping(className, palette),
    };
});
export default BryxPasswordStrengthChip;
